var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.space)?_c('img',{staticClass:"d-inline-block v-align-middle line-height-0 circle border",style:({
    width: ((_vm.size || 22) + "px"),
    height: ((_vm.size || 22) + "px")
  }),attrs:{"src":_vm.url}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }